<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸比对</h1>
		<!--  人脸特征比对，字符串类型特征-->
		<h2 class="doc_main_h2">人脸特征比对，字符串类型特征</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">float __stdcall SKFaceFeatureCompare(const char* pszBase64FeaA, const char* pszBase64FeaB);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pszBase64FeaA：第一个人脸的特征字符串</p>
        <p class="doc_main_p">（2）pszBase64FeaB：第二个人脸的特征字符串</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	float类型数据，范围[0-1]，值越大表示相似度越高。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">string strBase64FeaA = "TOgywJ………wuT/vmIDKkA=";     // 数据较长，此处仅做示意
string strBase64FeaB = "KtFEA…………+vkk6JUA="        // 数据较长，此处仅做示意
float fSimilarity = SKFaceFeatureCompare(strBase64FeaA.c_str(), strBase64FeaB.c_str());
</code></pre>
		<!--  人脸特征比对，unsigned char[] 类型特征-->
		<h2 class="doc_main_h2">人脸特征比对，unsigned char[] 类型特征</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">float __stdcall SKFaceFeatureCompareBin(unsigned char *pFeatureA, unsigned char *pFeatureB);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pFeatureA：第一个人脸的特征unsigned char[521 * sizeof(float)]类型</p>
        <p class="doc_main_p">（2）pFeatureB：第二个人脸的特征unsigned char[521 * sizeof(float)]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	float类型数据，范围[0-1]，值越大表示相似度越高。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">unsigned char *pFeatureA = ...;        // 通过图片检测获取人脸特征值
unsigned char *pFeatureB = ...;         // 通过图片检测获取人脸特征值
float fSimilarity = SKFaceFeatureCompareBin(pFeatureA, pFeatureB);</code></pre>
		<!--  人脸特征unsigned char[512 * sizeof(float)]转base64字符串 -->
		<h2 class="doc_main_h2">人脸特征unsigned char[512 * sizeof(float)]转base64字符串</h2>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall SKFaceBinfeatureToBase64(unsigned char* pBinFeature,char* pszBase64Feature);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBinFeature：要转换的人脸特征unsigned char[521 * sizeof(float)]类型</p>
        <p class="doc_main_p">（2）pszBase64Feature: base64转换后的人脸特征字符串</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	人脸特征Base64字符串类型
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">unsigned char *pBinFeature = ...;       // 通过图片检测获取人脸特征值
char szBase64Feature[PERSON_FEATURE_LEN+1];
SKFaceBinfeatureToBase64(pBinFeature, szBase64Feature);</code></pre>
		<!--  人脸特征base64字符串转unsigned char[512 * sizeof(float)] -->
		<h2 class="doc_main_h2">人脸特征base64字符串转unsigned char[512 * sizeof(float)]</h2>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall SKFaceBase64ToBinFeature(const char* pszBase64Feature,unsigned char* szBinFeature);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pszBase64Feature: 要转换的人脸特征base64字符串</p>
        <p class="doc_main_p">（2）szBinFeature：转换后的人脸特征unsigned char[521 * sizeof(float)]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	无
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 分配人脸特征内存空间
unsigned char szBinFeature[2048];   
const char *pszBase64Feature = ...; // base64后的人脸特征字符串
SKFaceBase64ToBinFeature(pszBase64Feature, szBinFeature);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','图片接口','人脸比对'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/image/faceContrast.vue